import { Component, Input, forwardRef, NgZone, Output, OnDestroy, EventEmitter, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BaseTranslation } from 'src/core/translation/model/translation.base';
import { recaptchaConsts } from './consts';

declare var grecaptcha;

@Component({
  selector: "adahi-recaptcha",
  templateUrl: './recaptcha.component.html',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RecaptchaComponent), multi: true },
  ]
})

export class RecaptchaComponent extends BaseTranslation implements ControlValueAccessor, OnDestroy {

  @Input()
  siteKey: string;

  @Input()
  captchaName: string;

  @Input()
  actionName: string

  @Input()
  theme: "light" | "dark";

  @Output()
  onResponse: EventEmitter<any> = new EventEmitter();

  @Output()
  onLoad: EventEmitter<any> = new EventEmitter();

  private _response;
  private _clientId;
  private _isLoaded: boolean;
  private _currentLang

  propagateChange: any = () => { };

  set Response(val: string) {
    this._response = val;
    this.propagateChange(this._response);
    this._ngZone.run(() => {
      this._response = val;
      this.propagateChange(this._response);
    });
  }

  get Response(): string {
    return this._response;
  }

  constructor(private _ngZone: NgZone, translate: TranslateService) {
    super(translate, _ngZone);

    this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
      this._currentLang = this.translate.instant('common.currentLanguage');
      this.loadScripts();
    });
  }

  ngOnDestroy(): void {
    this.onLoad.complete();
  }

  private loadScripts() {

    if (this._isLoaded) return;

    window[this.captchaName + 'onloadCallback'] = this.onloadCallback.bind(this);
    let src = String.format(recaptchaConsts.Url, this.captchaName, this._currentLang);
    //let src = recaptchaConsts.Url.replace("{0}" , this.captchaName).replace("{1}" , this._currentLang);
    let node = document.createElement('script') as HTMLScriptElement;
    node.src = src;
    node.async = true;
    node.defer = true;
    document.getElementsByTagName('head')[0].appendChild(node);

  }

  private onloadCallback() {

    this._isLoaded = true;

    this._clientId = grecaptcha.render(this.captchaName, {
      "sitekey": this.siteKey,
      "theme": this.theme,
      'size': 'invisible',
      'badge': 'inline',
      // 'callback': this.getResponseToken,
      // 'expired-callback': this.onExpired,
      // 'error-callback': this.onError,
    });

    //this.execute();
    this.onLoad.emit(this.execute);
  }

  public execute = () => {
    grecaptcha.execute(this._clientId, { action: this.actionName }).then(this.getResponseToken);
  }

  ngAfterViewInit() {
    //this.loadScripts();
  }

  private getResponseToken = (token) => {
    this.Response = token;
    this.onResponse.emit(token);
  }

  writeValue(obj: any): void {
    if ((obj == null || obj == '') && this._isLoaded) {
      if (grecaptcha != null) {
        grecaptcha.reset();
        this.Response = "";
      }
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

}
